<template>
  <div class="CharityCard">
    <div class="mainPanel">
      <div
        class="text-center"
        style="margin-bottom: 30px;"
      >
        <div class="font-bold text-large-4">
          巧巧郎公益
        </div>
        <div>為社會獻愛心巧巧郎義不容辭</div>
      </div>

      <div>
        <v-layout align-center>
          <div>
            <v-btn
              icon
              @click="$refs.mySwiper.$swiper.slidePrev()"
            >
              <v-icon
                size="40"
                color="grey"
              >
                navigate_before
              </v-icon>
            </v-btn>
          </div>
          <v-flex
            style="overflow: hidden;position: relative;"
          >
            <swiper
              ref="mySwiper"
              :options="swiperOptions"
            >
              <swiper-slide
                v-for="i in bannrCount"
                :key="i"
                class="text-xs-center"
                @click.native="openPhotoSwipe(i)"
              >
                <img
                  loading="lazy"
                  decoding="async"
                  :src="`https://static.kkren.com.tw/static/images/charity/appreciate/${i}.jpg`"
                  width="120"
                  height="170"
                  class="cursor-pointer"
                  style="object-fit: cover;"
                >
              </swiper-slide>
            </swiper>
          </v-flex>
          <div>
            <v-btn
              icon
              @click="$refs.mySwiper.$swiper.slideNext()"
            >
              <v-icon
                size="40"
                color="grey"
              >
                navigate_next
              </v-icon>
            </v-btn>
          </div>
        </v-layout>
      </div>
      <div
        v-if="list.length"
        class="mt-4"
      >
        <v-layout align-center>
          <div class="pb-4">
            <v-btn
              icon
              @click="$refs.listSwiper.$swiper.slidePrev()"
            >
              <v-icon
                size="40"
                color="grey"
              >
                navigate_before
              </v-icon>
            </v-btn>
          </div>
          <v-flex
            style="overflow: hidden;position: relative;"
          >
            <swiper
              ref="listSwiper"
              :options="listSwiperOptions"
            >
              <swiper-slide
                v-for="i in Math.ceil(list.length/4)"
                :key="i"
                class="text-xs-center"
              >
                <v-layout>
                  <template v-for="j in 4">
                    <v-flex
                      v-if="list[(i-1)*4+j-1]"
                      :key="list[(i-1)*4+j-1].poid"
                      style="flex:1"
                      class="mx-2 pb-2"
                    >
                      <CharityCardItem
                        :post="list[(i-1)*4+j-1]"
                      />
                    </v-flex>
                  </template>
                </v-layout>
              </swiper-slide>
            </swiper>
          </v-flex>
          <div class="pb-4">
            <v-btn
              icon
              @click="$refs.listSwiper.$swiper.slideNext()"
            >
              <v-icon
                size="40"
                color="grey"
              >
                navigate_next
              </v-icon>
            </v-btn>
          </div>
        </v-layout>
      </div>

      <!-- <Pager
        ref="pager"
        :size="20"
        :on-fetch="fetchList"
        pull
      /> -->
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import CharityCardItem from './CharityCardItem.vue'

export default {
  components: {
    CharityCardItem,
    Swiper,
    SwiperSlide,
  },
  data () {
    return {
      url: '',
      list: [],
      bannrCount: 13,
      count: 0,
      submitLoading: false,
      // 是否根据容器尺寸自动计算重绘
      autoResize: true,
      // 是否始终填满容器
      fillBox: true,
      // 列宽-有指定列数则此属性失效
      // colWidth: window.innerWidth / 6,
      colWidth: 200,
      // 列数
      col: 2,

      swiperOptions: {
        // loop: true,
        slidesPerView: 8,
        spaceBetween: 10,
        slidesPerGroup: 3,
        loopFillGroupWithBlank: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // pagination: {
        //   el: '.swiper-pagination'
        // },
      },
      listSwiperOptions: {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loopFillGroupWithBlank: true,
        // autoplay: {
        //   delay: 8000,
        //   disableOnInteraction: false
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        // pagination: {
        //   el: '.swiper-pagination'
        // },
      },
    }
  },
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const params = {
        page: 1,
        pageSize: 80,
        type: 'welfare',
      }
      const res = await this.$store.dispatch('post/index', params)
      this.list = res.data.list
    },
    // async fetchList ({ size, number }) {
    //   if (number === 1) {
    //     this.list = []
    //     this.count = 0
    //   }
    //   if (this.count > 0 && this.count <= this.list.length) {
    //     // 没数据就从现在的列表随机显示
    //     const tempList = this.list.slice(0, this.count).filter(item => {
    //       const lastList = this.list.slice(this.list.length - 30)
    //       return !lastList.includes(item)
    //     })
    //     for (let i = 0; i < size; i++) {
    //       this.list.push(tempList.splice(Math.floor(Math.random() * tempList.length), 1)[0])
    //     }
    //     return { total: this.list.length, size: this.list.length }
    //   }

    //   const params = {
    //     page: number,
    //     pageSize: size,
    //     type: 'welfare',
    //   }
    //   const res = await this.$store.dispatch('post/index', params)
    //   const newList = res.data.list
    //   this.list = this.list.concat(newList)
    //   this.count = Number(res.data.listInfo.count)
    //   return { total: res.data.listInfo.totalCount, size: newList.length }
    // },
    openPhotoSwipe (index) {
      console.log('openPhotoSwipe')
      const images = []
      for (let i = 1; i <= this.bannrCount; i++) {
        images.push(`https://static.kkren.com.tw/static/images/charity/appreciate/${i}.jpg`)
      }
      // `https://static.kkren.com.tw/static/images/charity/appreciate/${index}.jpg`
      this.$eventBus.$emit(this.$eventType.ViewImages, {
        index: index - 1,
        images,
      })
    },
  }
}
</script>

<style lang="postcss" scoped>
.CharityCard {
  padding: 30px 0;
}
.listWrap {
  margin: 0 auto;
  width: 100%;
  /* column-width: 100px; */
  column-count: 2;
  column-gap: 10px;
  > .item {
    margin-bottom: 10px;
    break-inside: avoid;
  }
}
</style>
